<template>
<v-card>
    <v-card-title class="py-3">Tickets</v-card-title>
    <v-card-text class="py-0">
        <TicketSearch :loading="loading" :default="params" @search="params = $event"/>
    </v-card-text>
    <v-card-text>
        <TicketList :params="params" :loading.sync="loading"/>
    </v-card-text>
</v-card>
</template>
<script>
import TicketSearch from '@components/entities/ticket/search';
import TicketList from '@components/entities/ticket';

export default {
    components: {
        TicketSearch,
        TicketList,
    },
    data: function () {
        const defaultParams = this.setQuery({
            date: this.$luxon.local().toISODate(),
        });
        return {
            options: {},
            loading: false,

            isModalOpen: false,
            item: null,

            default: defaultParams,
            params: {...defaultParams},
        };
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', '');
    },
    methods: {
        add: function () {
            this.item = null;
            this.isModalOpen = true;
        },
        edit: function (item) {
            this.item = item;
            this.isModalOpen = true;
        },
        setQuery: function (params = {}) {
            const query = {... this.$route.query};

            for (const key in query) {
                if (Object.hasOwnProperty.call(query, key)) {
                    const element = query[key];

                    if (key == 'numero') {
                        query[key] = element;
                        continue;
                    }

                    query[key] = /^-?[\d.]+(?:e-?\d+)?$/.test(element) ? Number.parseFloat(element): element;
                }
            }

            return { ... params, ... query };
        },
    },
}
</script>